var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAddFilled = function SvgUserAddFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.522 5.313a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.313 11.563c.46 0 .834.373.834.833v2.083h2.083a.833.833 0 1 1 0 1.667h-2.083v2.083a.833.833 0 0 1-1.667 0v-2.083h-2.083a.833.833 0 1 1 0-1.667h2.083v-2.083c0-.46.373-.834.833-.834",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.105 11.837c.105.05.158.166.143.28a2 2 0 0 0-.019.279v.583a.25.25 0 0 1-.25.25h-.583a2.083 2.083 0 1 0 0 4.167h.583a.25.25 0 0 1 .25.25v.583q0 .154.022.303c.022.152-.076.304-.229.313a5 5 0 0 1-.285.01H5.388c-1.515 0-2.686-.746-3.663-1.676-.565-.54-.847-1.146-.777-1.792.067-.609.432-1.105.817-1.481.615-.602 1.513-1.109 2.107-1.444q.205-.115.352-.202a9.4 9.4 0 0 1 3.501-1.229 9.6 9.6 0 0 1 2.675 0c.929.131 1.842.4 2.705.806"
  })));
};
export default SvgUserAddFilled;